<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="partners__background module__background"
        ></app-modulebackground>
        <div
            class="partners__container module__container"
            v-bind:class="{
                container__boxed: [1, 2, 5, 6].includes(module.layout.type),
                'container__boxed--half': [3, 4].includes(module.layout.type)
            }"
        >
            <div class="partners__header-extra" v-if="module.data.title || module.data.subtitle">
                <div class="partners__inner-row module__inner-row">
                    <div class="partners__inner-col module__inner-col">
                        <div class="partners__header module__header">
                            <h2
                                class="partners__title module__title font-h2 color-h2"
                                v-if="module.data.title"
                                v-html="module.data.title"
                            ></h2>
                            <h3
                                class="partners__subtitle module__subtitle font-h3 color-h3"
                                v-if="module.data.subtitle"
                                v-html="module.data.subtitle"
                            ></h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="partners__inner module__inner">
                <div
                    class="partners__inner--main module__inner--main"
                    v-bind:class="{ 'col__width--half': [5, 6].includes(module.layout.type) }"
                >
                    <div class="partners__inner-row module__inner-row">
                        <div class="partners__inner-col module__inner-col">
                            <div class="partners__content-block module__content-block">
                                <div
                                    class="partners__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="partners__inner-row module__inner-row">
                                        <div class="partners__inner-col module__inner-col">
                                            <div
                                                class="partners__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="partners__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="partners__inner-row module__inner-row">
                                        <div class="partners__inner-col module__inner-col">
                                            <div
                                                ref="slider"
                                                per-page="4"
                                                per-page-lg="3"
                                                per-page-md="2"
                                                per-page-sm="1"
                                                class="partners__list-wrap"
                                                v-bind:class="{
                                                    slider:
                                                        [1, 2].includes(module.layout.type) &&
                                                        items.length > 4
                                                }"
                                            >
                                                <ul class="partners__list module__list">
                                                    <li
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        class="partners__list-item module__list-item"
                                                        v-bind:class="{
                                                            'col__width--full': [
                                                                3,
                                                                4,
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            v-if="items__value.data"
                                                            class="partners__teaser-box"
                                                            v-bind:class="{
                                                                'module__teaser-box--horizontal': [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5,
                                                                    6
                                                                ].includes(module.layout.type)
                                                            }"
                                                        >
                                                            <app-moduleimage
                                                                v-if="
                                                                    [1, 2].includes(
                                                                        module.layout.type
                                                                    ) && items__value.data.image
                                                                "
                                                                :data="items__value.data.image"
                                                                :tag="'img'"
                                                                :custom-class="
                                                                    'partners__list-item-image module__image'
                                                                "
                                                            ></app-moduleimage>
                                                            <div
                                                                class="module__teaser-box--text"
                                                                v-bind:class="{
                                                                    'flex--wrap': [
                                                                        3,
                                                                        4,
                                                                        5,
                                                                        6
                                                                    ].includes(module.layout.type)
                                                                }"
                                                            >
                                                                <div
                                                                    v-if="items__value.data.name"
                                                                    class="partners__list-item-name font-bold"
                                                                >
                                                                    {{ items__value.data.name }}
                                                                </div>

                                                                <a
                                                                    v-if="items__value.data.link"
                                                                    v-bind:href="
                                                                        items__value.data.link
                                                                    "
                                                                    target="_blank"
                                                                    class="partners__list-item-link module__link--underlined"
                                                                >
                                                                    Website
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="partners__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="partners__inner-col module__inner-col">
                            <div class="partners__cta module__cta">
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'partners__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'partners__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'partners__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="partners__inner--image module__inner--image"
                    v-bind:class="{ 'col__width--half': [5, 6].includes(module.layout.type) }"
                    v-if="
                        [1, 2, 3, 4, 5, 6].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[1, 2, 3, 4, 5, 6].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'partners__moduleimage module__moduleimage'"
                    ></app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems']),
        items() {
            return this.getListItems('deha.user.misc.partners');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
